import * as Logger from "js-logger";
import { Exit } from "slotworks/state-machine/data/exit";
import { StateMachine } from "slotworks/state-machine/state-machine";
import CancelGroup from "slotworks/utils/contracts/cancel-group";
abstract class State {

    public active: boolean;
    public params: any;

    protected stateMachine: StateMachine;

    protected cancelGroup: CancelGroup = new CancelGroup();

    constructor(stateMachine: StateMachine) {
        this.stateMachine = stateMachine;
    }

    /**
     * Call when the state completes naturally (for example an animation completes)
     */
    public complete() {
        this.cancelGroup.clear();
        this.stateMachine.changeState(Exit.Complete, this);
    }

    /**
     * Call when the state has accepted the users request to exit
     */
    public skip() {
        this.cancelGroup.cancel();
        this.stateMachine.changeState(Exit.Skip, this);
    }

    /**
     * Call when something when wrong during the state
     */
    public error() {
        this.cancelGroup.clear();
        this.stateMachine.changeState(Exit.Error, this);
    }

    /**
     * Executed when a user attempts to exit the state manually (for example by pressing the spin button)
     */
    public onSkip(cascaded?: boolean) {
        // skip
    }

    /**
     * Executed automatically when the state is entered
     */
    public onEnter(cascadeSkip?: boolean) {
        Logger.debug("onEnter not implemented on ", this);
    }

    /**
     * Executed automatically by the state machine when the state is exited (via any means)
     */
    public onExit() {
        Logger.debug("onExit not implemented on ", this);
    }
}

export default State;
